module.exports = __webpack_public_path__ + "media/dashboard/assets/images/cog-68bfc67ac60e6488f643f801ae268c6c.svg";